var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.2759C1 11.7094 1.43452 13.3399 2.41314 14.2296C2.90339 14.6753 3.61655 15.0146 4.7164 15.2368C5.82272 15.4604 7.24982 15.5518 9.10345 15.5518C10.9571 15.5518 12.3842 15.4604 13.4905 15.2368C14.5903 15.0146 15.3035 14.6753 15.7938 14.2296C16.7724 13.3399 17.2069 11.7094 17.2069 8.2759C17.2069 4.8424 16.7724 3.21187 15.7938 2.32222C15.3035 1.87653 14.5903 1.53716 13.4905 1.31495C12.3842 1.09143 10.9571 1.00003 9.10345 1.00003C7.24982 1.00003 5.82272 1.09143 4.7164 1.31495C3.61655 1.53716 2.90339 1.87653 2.41314 2.32222C1.43452 3.21187 1 4.8424 1 8.2759Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3794 4.33388C20.5498 1.54145 22.5288 2.21272 22.8966 4.33387C23.2645 6.45503 23.2645 9.82752 22.8966 11.9353C22.5796 14.7278 20.5498 14.8056 17.3794 12.0131",
    stroke: "#404040",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortIcon);
export default __webpack_public_path__ + "static/media/ShortIcon.6995242e6f4ae28ae7e3915a26675f6e.svg";
export { ForwardRef as ReactComponent };